import React from 'react'
import { Alert } from 'react-bootstrap'
import {
  Checkbox, validateFieldsEx, IField, Label,
} from '../../../../shared/fields'
import { ApplicationModel } from '../../../../models/ApplicationModel'
import EMDGAccordion from '../../../../shared/EMDGAccordion'

export interface Props {
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    visible: boolean
    preview?: boolean
}

export interface State {
  validationError: boolean
}

export default class EventsContainer extends React.Component<Props, State> implements IField {
  isEventHeldInAustralia: Checkbox
  isEventHeldOnline: Checkbox
  eventNotHeldAnywhere: Checkbox
  hiddenCheckboxForValidation: Checkbox

  constructor(props: Props) {
    super(props)

    this.state = {
      validationError: false,
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const { model, visible } = this.props
    const { validationError } = this.state

    if (validationError && (model.isEventHeldInAustralia || model.isEventHeldOnline || model.eventNotHeldAnywhere || !visible)) {
      this.setState({ validationError: false })
    }
  }

  handleEventnotHeldAnywhere = (val: boolean) => {
    const { onChange } = this.props

    if (val) {
      onChange({ eventNotHeldAnywhere: val || null, isEventHeldInAustralia: null, isEventHeldOnline: null })
    } else {
      onChange({ eventNotHeldAnywhere: val || null })
    }
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    const { model, visible } = this.props
    if (model.eventNotHeldAnywhere) {
      callback && callback(false) // don't ever continue!
      return
    }
    this.setState({
      validationError:
        !model.isEventHeldInAustralia
        && !model.isEventHeldOnline
        && !model.eventNotHeldAnywhere
        && visible,
    }, () => {
      validateFieldsEx(
        focus,
        callback,
        this.hiddenCheckboxForValidation,
      )
    })
  }

  render() {
    const {
      visible, model, onChange, preview,
    } = this.props
    const { validationError } = this.state

    return (
      visible && (
      <div style={{ marginTop: '30px' }}>
        { preview && <h4>Events</h4>}
        <EMDGAccordion expanded header="Events">

          <Label
            label="77. Select if the event(s) is/are: *"
            preview={preview}
          />
          <i>
            For an event to be eligible, it must be of substantially Australian origin and it must be held in Australia
            or hosted online by an Australian person to international customers.
          </i>
          <Checkbox
            ref={(r) => { this.hiddenCheckboxForValidation = r }}
            id="hiddenCheckboxForValidation"
            required={!model.isEventHeldInAustralia && !model.isEventHeldOnline && !model.eventNotHeldAnywhere}
            onChange={() => {}}
            value={false}
            label=""
            className="hidden-checkbox"
          />
          <Checkbox
            ref={(r) => { this.isEventHeldInAustralia = r }}
            id="isEventHeldInAustralia"
            required={false}
            onChange={(val) => onChange({ isEventHeldInAustralia: val || null })}
            value={model.isEventHeldInAustralia}
            label="Physically held in Australia"
            disabled={model.eventNotHeldAnywhere}
            preview={preview}
            validateError={validationError}
          />

          <Checkbox
            ref={(r) => { this.isEventHeldOnline = r }}
            id="isEventHeldOnline"
            required={false}
            onChange={(val) => onChange({ isEventHeldOnline: val || null })}
            value={model.isEventHeldOnline}
            label="Online provided by an Australian person"
            disabled={model.eventNotHeldAnywhere}
            preview={preview}
            validateError={validationError}
          />

          <Checkbox
            ref={(r) => { this.eventNotHeldAnywhere = r }}
            id="eventNotHeldAnywhere"
            required={false}
            onChange={(val) => this.handleEventnotHeldAnywhere(val)}
            value={model.eventNotHeldAnywhere}
            label="None of the above"
            preview={preview}
            validateError={validationError}
          />
          {validationError ? (<div className="form-error">This field is required</div>) : null}
          { model.eventNotHeldAnywhere && (
          <Alert className="emdg-page-alerts emdg-page-alerts--error">
            You are
            {' '}
            <b>not</b>
            {' '}
            eligible to apply for a grant as you do not have an eligible event.
          </Alert>
          ) }

        </EMDGAccordion>
      </div>
      )
    )
  }
}
